export interface Movie {
  id: number;
  title: string;
  titleEn: string;
  year: number;
  rating: number;
  category: string;
  categorySlug: string;
  duration: string;
  region: string;
  director: string;
  cast: string[];
  description: string;
  summary: string;
  poster: string;
  banner: string;
  isHot: boolean;
  isNew: boolean;
  isClassic: boolean;
  releaseDate: string;
  tags: string[];
  viewCount: number;
  contentHtml: string;
}

export const movies: Movie[] = [
  {
    id: 1,
    title: '星际迷航：新纪元',
    titleEn: 'Star Trek: New Era',
    year: 2026,
    rating: 9.2,
    category: '科幻',
    categorySlug: 'scifi',
    duration: '148分钟',
    region: '美国',
    director: '克里斯托弗·诺兰',
    cast: ['汤姆·克鲁斯', '赞达亚', '基里安·墨菲', '安雅·泰勒-乔伊'],
    description: '2026年最受期待的科幻巨制，讲述人类探索未知星系、面对外星文明的壮丽旅程。',
    summary: '在遥远的未来，人类已经建立了庞大的星际帝国。当一支探险队在银河系边缘发现了一个神秘信号时，一场改变人类命运的旅程就此展开。这支由精英科学家和宇航员组成的团队，将面对前所未有的挑战，揭开宇宙最深处的秘密。',
    poster: 'https://readdy.ai/api/search-image?query=epic%20sci-fi%20movie%20poster%20with%20spaceship%20and%20stars%20cinematic%20lighting%20dramatic%20composition%20dark%20background%20with%20neon%20blue%20and%20orange%20accents%20movie%20poster%20style&width=600&height=900&seq=movie-poster-01&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=epic%20cinematic%20space%20scene%20with%20massive%20starship%20nebula%20galaxy%20dramatic%20lighting%20film%20grain%20texture%20movie%20banner%20style%20dark%20moody%20atmosphere&width=1600&height=700&seq=movie-banner-01&orientation=landscape',
    isHot: true,
    isNew: true,
    isClassic: false,
    releaseDate: '2026-07-15',
    tags: ['IMAX', '3D', '杜比全景声'],
    viewCount: 12850000,
    contentHtml: '<h2>剧情简介</h2><p>在遥远的未来，人类已经建立了庞大的星际帝国。当一支探险队在银河系边缘发现了一个神秘信号时，一场改变人类命运的旅程就此展开。</p><p>这支由精英科学家和宇航员组成的团队，将面对前所未有的挑战：陌生的星球环境、未知的外星文明、以及隐藏在宇宙深处的巨大秘密。在浩瀚星辰之间，他们不仅要完成科学探索的使命，更要直面人性的考验。</p><h2>幕后制作</h2><p>本片由奥斯卡获奖导演克里斯托弗·诺兰执导，耗资3.5亿美元，历时四年精心打磨。影片采用最新的IMAX摄影技术，在真实的太空模拟环境中拍摄，为观众呈现前所未有的视觉震撼。</p><p>特效团队由工业光魔（ILM）顶级艺术家组成，创造了超过2000个视觉特效镜头，每一个外星场景都经过精心设计，力求给观众带来最真实的外星体验。</p><h2>演职员表</h2><p>汤姆·克鲁斯在片中饰演主角杰克·米勒上校，这是他职业生涯中最具挑战性的角色之一。为拍摄本片，他进行了长达六个月的宇航员训练。</p><p>赞达亚饰演天才天体物理学家艾玛·陈博士，她的表演为这部科幻大片注入了深度与情感。</p><p>基里安·墨菲和安雅·泰勒-乔伊分别饰演神秘的外星联络官和勇敢的探险队员，两位实力派演员的加盟让影片的表演层次更加丰富。</p><h2>影片评价</h2><p>"一部真正意义上的太空史诗，诺兰再次证明了他是当今最伟大的导演之一。" —— 《好莱坞报道》</p><p>"视觉与思想的完美结合，2026年最好的科幻电影。" —— 《综艺》</p><p>"每一帧都是一幅画，每一个场景都令人窒息。" —— 《帝国》杂志</p>',
  },
  {
    id: 2,
    title: '长安十二时辰',
    titleEn: 'The Longest Day in Chang\'an',
    year: 2026,
    rating: 8.9,
    category: '动作',
    categorySlug: 'action',
    duration: '136分钟',
    region: '中国',
    director: '曹盾',
    cast: ['易烊千玺', '雷佳音', '周一围', '热依扎'],
    description: '改编自马伯庸同名小说，讲述唐代长安城一场惊心动魄的生死追凶。',
    summary: '天宝三载，上元节前夕，长安城混入可疑狼卫。死囚张小敬临危受命，与少年名士李必携手，在十二时辰内拯救长安。繁华盛世的背后，隐藏着惊天阴谋。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20action%20movie%20poster%20ancient%20Tang%20Dynasty%20warrior%20with%20sword%20dramatic%20red%20and%20gold%20tones%20cinematic%20composition%20dark%20moody%20background&width=600&height=900&seq=movie-poster-02&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=ancient%20Chinese%20Tang%20Dynasty%20city%20at%20night%20with%20lanterns%20and%20pagodas%20cinematic%20lighting%20epic%20scale%20film%20grain%20dramatic%20atmosphere&width=1600&height=700&seq=movie-banner-02&orientation=landscape',
    isHot: true,
    isNew: false,
    isClassic: false,
    releaseDate: '2026-06-20',
    tags: ['IMAX', '古装', '悬疑'],
    viewCount: 9650000,
    contentHtml: '<h2>剧情简介</h2><p>天宝三载，上元节前夕，长安城混入可疑狼卫。死囚张小敬临危受命，与少年名士李必携手，在十二时辰内拯救长安。</p><p>繁华盛世的背后，隐藏着惊天阴谋。从西域商贾到朝廷重臣，从地下黑市到皇家禁苑，张小敬和李必穿梭于长安城的每一个角落，与时间赛跑，与命运博弈。</p><h2>幕后制作</h2><p>本片耗资5亿人民币，搭建了1:1还原的唐代长安城实景，总面积超过70万平方米。剧组邀请了中国顶尖的历史顾问团队，确保每一个细节都符合唐代风貌。</p><p>武术指导由袁和平亲自操刀，融合了传统武术与现代动作设计，呈现出独具东方美学的动作场面。</p><h2>演职员表</h2><p>易烊千玺饰演李必，将少年名士的风骨与智慧诠释得淋漓尽致。雷佳音饰演张小敬，粗犷中带着细腻，为角色注入了丰富的层次感。</p><h2>影片评价</h2><p>"国产古装动作片的里程碑之作，画面精美绝伦，故事扣人心弦。" ——《人民日报》</p><p>"将中国传统文化与现代电影语言完美融合，令人叹为观止。" ——《光明日报》</p>',
  },
  {
    id: 3,
    title: '深海迷踪',
    titleEn: 'Deep Sea Mystery',
    year: 2026,
    rating: 8.7,
    category: '悬疑',
    categorySlug: 'suspense',
    duration: '122分钟',
    region: '美国',
    director: '大卫·芬奇',
    cast: ['杰克·吉伦哈尔', '鲁妮·玛拉', '威廉·达福'],
    description: '深海科考队发现了一座沉没的古城，随之而来的是一连串无法解释的神秘事件。',
    summary: '一支深海科考队在马里亚纳海沟底部发现了一座未知的古城遗迹。当他们深入探索时，诡异的事件接连发生。通讯中断、队员失踪、仪器失灵……深海中似乎潜藏着某种超乎想象的力量。',
    poster: 'https://readdy.ai/api/search-image?query=deep%20sea%20mystery%20thriller%20movie%20poster%20dark%20ocean%20abyss%20eerie%20blue%20lighting%20submarine%20silhouette%20cinematic%20suspense%20atmosphere&width=600&height=900&seq=movie-poster-03&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=deep%20ocean%20abyss%20dark%20underwater%20scene%20ancient%20ruins%20mysterious%20blue%20light%20cinematic%20suspense%20film%20grain%20texture%20eerie%20atmosphere&width=1600&height=700&seq=movie-banner-03&orientation=landscape',
    isHot: true,
    isNew: false,
    isClassic: false,
    releaseDate: '2026-07-08',
    tags: ['悬疑', '深海', '惊悚'],
    viewCount: 8230000,
    contentHtml: '<h2>剧情简介</h2><p>一支深海科考队在马里亚纳海沟底部发现了一座未知的古城遗迹。当他们深入探索时，诡异的事件接连发生。</p><p>通讯中断、队员失踪、仪器失灵……深海中似乎潜藏着某种超乎想象的力量。科考队成员必须在氧气耗尽之前揭开古城的秘密，同时还要面对来自内心深处的恐惧。</p><h2>幕后制作</h2><p>导演大卫·芬奇以独特的视觉风格著称，本片采用了革命性的水下拍摄技术，在真实深海环境中完成了大部分镜头。</p><p>影片的声效设计由奥斯卡获奖音效团队打造，深海的压迫感通过声音被完美传达给观众。</p><h2>演职员表</h2><p>杰克·吉伦哈尔饰演科考队队长马克·安德森，他的表演深沉而有力，完美展现了一个在极端环境中挣扎的领导者形象。</p><p>鲁妮·玛拉饰演海洋生物学家莎拉·金博士，她的细腻演技为这部悬疑片增添了情感深度。</p><h2>影片评价</h2><p>"芬奇再次证明他是悬疑片的大师，深海的幽闭恐惧被拍得令人窒息。" ——《纽约时报》</p><p>"一部让你不敢再下海的电影，心理惊悚的极致体验。" ——《滚石》</p>',
  },
  {
    id: 4,
    title: '喜剧之王2',
    titleEn: 'King of Comedy 2',
    year: 2026,
    rating: 8.5,
    category: '喜剧',
    categorySlug: 'comedy',
    duration: '110分钟',
    region: '中国',
    director: '周星驰',
    cast: ['沈腾', '马丽', '艾伦', '贾玲'],
    description: '周星驰时隔多年再度出山，讲述一个普通演员追逐梦想的爆笑故事。',
    summary: '小人物阿星的演员梦从未熄灭。在这个娱乐至上的时代，他凭借对表演的纯粹热爱，在一系列啼笑皆非的误会和巧合中，最终找到了属于自己的舞台。笑中带泪，致敬每一个追梦人。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20movie%20poster%20funny%20actor%20on%20stage%20bright%20warm%20colors%20spotlight%20theater%20background%20joyful%20cinematic%20style&width=600&height=900&seq=movie-poster-04&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=grand%20theater%20stage%20with%20spotlights%20red%20curtains%20warm%20atmosphere%20cinematic%20comedy%20film%20style%20bright%20and%20cheerful%20lighting&width=1600&height=700&seq=movie-banner-04&orientation=landscape',
    isHot: false,
    isNew: true,
    isClassic: false,
    releaseDate: '2026-07-01',
    tags: ['喜剧', '励志', '周星驰'],
    viewCount: 11200000,
    contentHtml: '<h2>剧情简介</h2><p>小人物阿星的演员梦从未熄灭。在这个娱乐至上的时代，他凭借对表演的纯粹热爱，在一系列啼笑皆非的误会和巧合中，最终找到了属于自己的舞台。</p><p>从龙套到主演，从被嘲笑到被认可，阿星的每一步都走得艰辛又搞笑。当梦想的光芒照进现实，笑中带泪的故事直击每一个追梦人的心灵。</p><h2>幕后制作</h2><p>周星驰导演时隔八年再度执导筒，亲自参与剧本创作。影片延续了星爷一贯的无厘头喜剧风格，同时融入了更多对当下社会现象的思考。</p><p>沈腾和马丽的再度合作成为影片最大看点之一，两人的默契配合让现场笑料不断。</p><h2>演职员表</h2><p>沈腾饰演阿星，将小人物的执着与搞笑演绎得入木三分。马丽、艾伦、贾玲等喜剧大咖的加盟让影片笑点密集、金句频出。</p><h2>影片评价</h2><p>"星爷回来了！这才是真正的喜剧，笑中带泪，直击人心。" ——《新浪娱乐》</p><p>"沈腾+马丽的组合永远不会让人失望，2026年最好笑的电影。" ——《豆瓣电影》</p>',
  },
  {
    id: 5,
    title: '霸王别姬',
    titleEn: 'Farewell My Concubine',
    year: 1993,
    rating: 9.6,
    category: '剧情',
    categorySlug: 'drama',
    duration: '171分钟',
    region: '中国',
    director: '陈凯歌',
    cast: ['张国荣', '巩俐', '张丰毅'],
    description: '华语电影的巅峰之作，跨越半个世纪的悲欢离合，一段刻骨铭心的梨园传奇。',
    summary: '段小楼与程蝶衣从小在京剧班学艺，两人合演《霸王别姬》誉满京城。但历经半个世纪的世事变迁，二人命运交织纠缠，最终走向了无法挽回的悲剧。这部华语电影史上的不朽经典，以其深刻的人文关怀和精湛的艺术表现力，感动了全世界的观众。',
    poster: 'https://readdy.ai/api/search-image?query=classic%20Chinese%20Peking%20opera%20movie%20poster%20elegant%20actor%20in%20traditional%20costume%20dramatic%20lighting%20vintage%20film%20aesthetic%20gold%20and%20red%20tones&width=600&height=900&seq=movie-poster-05&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=traditional%20Chinese%20Peking%20opera%20stage%20with%20performers%20in%20elaborate%20costumes%20vintage%20atmosphere%20dramatic%20lighting%20classic%20cinema%20style&width=1600&height=700&seq=movie-banner-05&orientation=landscape',
    isHot: false,
    isNew: false,
    isClassic: true,
    releaseDate: '1993-01-01',
    tags: ['经典', '文艺', '戛纳金棕榈'],
    viewCount: 56000000,
    contentHtml: '<h2>剧情简介</h2><p>段小楼与程蝶衣从小在京剧班学艺，两人合演《霸王别姬》誉满京城。但历经半个世纪的世事变迁，二人命运交织纠缠，最终走向了无法挽回的悲剧。</p><p>从民国到新中国，从抗日战争到文化大革命，两个京剧演员的命运如同他们演绎的霸王和虞姬一样，在大时代的洪流中无法自主。</p><h2>获奖记录</h2><p>本片荣获第46届戛纳国际电影节金棕榈奖，是迄今为止唯一获得该奖项的华语电影。此外还获得了金球奖最佳外语片、英国电影学院奖最佳外语片等多项国际大奖。</p><h2>演职员表</h2><p>张国荣饰演程蝶衣，这是他演艺生涯中最伟大的角色。他将程蝶衣的痴、怨、悲、美演绎到了极致，创造了电影史上最令人难忘的角色之一。</p><p>巩俐饰演菊仙，张丰毅饰演段小楼，三位演员的表演堪称完美。</p><h2>影片评价</h2><p>"华语电影的巅峰之作，每一帧都是艺术。" ——《电影手册》</p><p>"一个时代的缩影，一部不朽的经典，张国荣的表演令人心碎。" ——《卫报》</p>',
  },
  {
    id: 6,
    title: '赛博朋克2077：夜之城',
    titleEn: 'Cyberpunk 2077: Night City',
    year: 2025,
    rating: 8.3,
    category: '科幻',
    categorySlug: 'scifi',
    duration: '155分钟',
    region: '美国',
    director: '丹尼斯·维伦纽瓦',
    cast: ['基努·里维斯', '安娜·德·阿玛斯', '迈克尔·B·乔丹'],
    description: '改编自经典游戏，讲述义体战士在霓虹闪烁的夜之城中寻找真相的故事。',
    summary: '2077年，科技高度发达的未来世界，人类可以通过植入义体获得超能力。雇佣兵V在夜之城接下了一单看似普通的委托，却意外卷入了一场涉及巨型企业、人工智能和人类命运的惊天阴谋。',
    poster: 'https://readdy.ai/api/search-image?query=cyberpunk%20movie%20poster%20neon%20city%20noir%20style%20futuristic%20warrior%20with%20cybernetic%20implants%20dark%20rainy%20street%20pink%20and%20cyan%20neon%20lights&width=600&height=900&seq=movie-poster-06&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=futuristic%20cyberpunk%20city%20at%20night%20neon%20lights%20holograms%20flying%20cars%20rain%20slick%20streets%20dystopian%20atmosphere%20cinematic%20style%20pink%20and%20cyan%20tones&width=1600&height=700&seq=movie-banner-06&orientation=landscape',
    isHot: false,
    isNew: false,
    isClassic: false,
    releaseDate: '2025-12-25',
    tags: ['科幻', '赛博朋克', '动作'],
    viewCount: 14500000,
    contentHtml: '<h2>剧情简介</h2><p>2077年，科技高度发达的未来世界，人类可以通过植入义体获得超能力。雇佣兵V在夜之城接下了一单看似普通的委托，却意外卷入了一场涉及巨型企业、人工智能和人类命运的惊天阴谋。</p><p>在霓虹闪烁的夜之城中，V必须在各方势力的夹缝中求生，同时揭开一个足以改变世界格局的秘密。</p><h2>幕后制作</h2><p>导演丹尼斯·维伦纽瓦以《银翼杀手2049》奠定了其在科幻电影领域的地位。本片耗资3.8亿美元，打造了一个前所未有的赛博朋克视觉世界。</p><p>影片采用了最先进的虚拟制作技术，夜之城的每一个角落都充满了令人惊叹的细节，从霓虹招牌到全息广告，从地下黑市到企业总部，呈现出一个栩栩如生的未来世界。</p><h2>演职员表</h2><p>基努·里维斯饰演主角V，他将雇佣兵V的冷酷与温情完美融合。安娜·德·阿玛斯和迈克尔·B·乔丹的精彩表现为影片增添了更多层次。</p><h2>影片评价</h2><p>"一部视觉上令人窒息的科幻杰作，赛博朋克美学的终极呈现。" ——《帝国》</p><p>"维伦纽瓦又一次创造了科幻电影的新高度。" ——《好莱坞报道》</p>',
  },
  {
    id: 7,
    title: '功夫',
    titleEn: 'Kung Fu Hustle',
    year: 2004,
    rating: 8.8,
    category: '喜剧',
    categorySlug: 'comedy',
    duration: '99分钟',
    region: '中国',
    director: '周星驰',
    cast: ['周星驰', '元秋', '元华', '黄圣依'],
    description: '周星驰的巅峰之作，将功夫与喜剧完美结合，创造了一部令人拍案叫绝的动作喜剧。',
    summary: '小混混阿星误闯猪笼城寨，本想敲诈勒索，却意外卷入了一场正邪大战。隐藏在城寨中的各路武林高手纷纷现身，一场惊天动地的功夫对决就此展开。',
    poster: 'https://readdy.ai/api/search-image?query=kung%20fu%20comedy%20movie%20poster%20martial%20arts%20action%20Chinese%20style%20dynamic%20pose%20warm%20colors%20vintage%20film%20aesthetic%20dramatic%20composition&width=600&height=900&seq=movie-poster-07&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=classic%201940s%20Shanghai%20neighborhood%20Pig%20Sty%20Alley%20style%20old%20Chinese%20apartment%20complex%20warm%20lighting%20nostalgic%20cinematic%20atmosphere&width=1600&height=700&seq=movie-banner-07&orientation=landscape',
    isHot: false,
    isNew: false,
    isClassic: true,
    releaseDate: '2004-12-23',
    tags: ['经典', '功夫', '周星驰'],
    viewCount: 89000000,
    contentHtml: '<h2>剧情简介</h2><p>小混混阿星误闯猪笼城寨，本想敲诈勒索，却意外卷入了一场正邪大战。</p><p>隐藏在城寨中的各路武林高手纷纷现身——太极拳、五郎八卦棍、十二路谭腿、狮吼功……一场惊天动地的功夫对决就此展开。阿星也在这一过程中觉醒了自己体内的绝世武功——如来神掌。</p><h2>幕后制作</h2><p>本片是周星驰自编自导自演的作品，历时三年精心打磨。影片邀请了众多真正的武术高手参演，所有打斗场面都是实拍完成。</p><p>影片的武术设计融合了中国传统武术与漫画式夸张风格，创造了独一无二的视觉语言。</p><h2>演职员表</h2><p>周星驰在片中将无厘头喜剧与硬核功夫完美结合。元秋饰演的包租婆和元华饰演的包租公成为影史经典角色。</p><h2>影片评价</h2><p>"功夫电影的里程碑，周星驰的才华在这部电影中得到了最完美的展现。" ——《时代周刊》</p><p>"动作设计的天花板，20年过去了依然无人超越。" ——《豆瓣电影》</p>',
  },
  {
    id: 8,
    title: '昨日重现',
    titleEn: 'Yesterday Once More',
    year: 2026,
    rating: 8.4,
    category: '爱情',
    categorySlug: 'romance',
    duration: '128分钟',
    region: '中国',
    director: '张艺谋',
    cast: ['刘亦菲', '朱一龙', '周冬雨'],
    description: '张艺谋导演首部纯爱电影，讲述一段跨越三十年的刻骨铭心的爱情故事。',
    summary: '上世纪90年代，北京胡同里，少年林峰和少女苏然相识相知。命运的捉弄让他们分离，三十年后的重逢又将带来怎样的故事？一段穿越时光的爱恋，温暖了整个银幕。',
    poster: 'https://readdy.ai/api/search-image?query=romantic%20Chinese%20movie%20poster%20couple%20in%20vintage%201990s%20Beijing%20alley%20soft%20warm%20lighting%20nostalgic%20atmosphere%20love%20story%20elegant%20composition&width=600&height=900&seq=movie-poster-08&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=vintage%201990s%20Beijing%20hutong%20alley%20old%20neighborhood%20warm%20golden%20sunset%20light%20nostalgic%20romantic%20cinematic%20atmosphere%20film%20grain&width=1600&height=700&seq=movie-banner-08&orientation=landscape',
    isHot: false,
    isNew: true,
    isClassic: false,
    releaseDate: '2026-06-14',
    tags: ['爱情', '文艺', '张艺谋'],
    viewCount: 7200000,
    contentHtml: '<h2>剧情简介</h2><p>上世纪90年代，北京胡同里，少年林峰和少女苏然相识相知。命运的捉弄让他们分离，三十年后的重逢又将带来怎样的故事？</p><p>从青涩的初恋到成熟的回首，一段穿越时光的爱恋，温暖了整个银幕。这不仅是一个爱情故事，更是一代人的青春记忆。</p><h2>幕后制作</h2><p>张艺谋导演首次执导纯爱题材，用他标志性的视觉美学重新定义了华语爱情电影。影片在北京老胡同实景拍摄，复原了90年代的北京风貌。</p><p>配乐由谭盾操刀，融合了中国传统乐器与西方交响乐，为这段跨越时空的爱情谱写了动人的乐章。</p><h2>演职员表</h2><p>刘亦菲和朱一龙的组合被称为"神仙阵容"，两人在片中的化学反应令人心动。周冬雨特别出演年轻时代的苏然，她的灵气为角色注入了鲜活的生命力。</p><h2>影片评价</h2><p>"张艺谋拍爱情也这么美，每一帧都像一幅油画。" ——《南方周末》</p><p>"刘亦菲和朱一龙的化学反应太好了，这才是真正的银幕情侣。" ——《新浪娱乐》</p>',
  },
  {
    id: 9,
    title: '无间道',
    titleEn: 'Infernal Affairs',
    year: 2002,
    rating: 9.3,
    category: '动作',
    categorySlug: 'action',
    duration: '101分钟',
    region: '中国香港',
    director: '刘伟强',
    cast: ['刘德华', '梁朝伟', '黄秋生', '曾志伟'],
    description: '香港警匪片的巅峰之作，一部关于身份、忠诚与背叛的经典。',
    summary: '警方卧底陈永仁潜伏在黑帮老大韩琛身边多年，而黑帮安插在警队的刘建明也在步步高升。当双方都意识到对方阵营中有内鬼时，一场惊心动魄的无间地狱就此展开。',
    poster: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20crime%20thriller%20movie%20poster%20two%20men%20in%20suits%20dark%20moody%20lighting%20film%20noir%20style%20suspense%20tense%20atmosphere%20classic%20cinema&width=600&height=900&seq=movie-poster-09&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20city%20rooftop%20at%20dusk%20dramatic%20sky%20neon%20lights%20in%20distance%20film%20noir%20atmosphere%20classic%20crime%20thriller%20cinematic%20style&width=1600&height=700&seq=movie-banner-09&orientation=landscape',
    isHot: false,
    isNew: false,
    isClassic: true,
    releaseDate: '2002-12-12',
    tags: ['经典', '警匪', '卧底'],
    viewCount: 102000000,
    contentHtml: '<h2>剧情简介</h2><p>警方卧底陈永仁潜伏在黑帮老大韩琛身边多年，而黑帮安插在警队的刘建明也在步步高升。</p><p>当双方都意识到对方阵营中有内鬼时，一场惊心动魄的无间地狱就此展开。每个人都想做好人，但命运却让他们身不由己。经典的"天台对决"场景至今仍被影迷津津乐道。</p><h2>幕后制作</h2><p>影片由刘伟强和麦兆辉联合执导，被称为"香港电影的救市之作"。影片以其精巧的剧本、紧凑的节奏和出色的表演，重新定义了警匪片类型。</p><p>好莱坞翻拍版《无间行者》荣获奥斯卡最佳影片，足见原作的剧本有多么出色。</p><h2>演职员表</h2><p>梁朝伟凭借陈永仁一角荣获金像奖和金马奖双料影帝。刘德华饰演的刘建明同样精彩，两个角色形成了完美的镜像对照。</p><p>黄秋生和曾志伟的配角表演同样令人难忘，为影片增添了厚度。</p><h2>影片评价</h2><p>"港产警匪片的巅峰，没有之一。剧本之精巧，表演之出色，至今无人能及。" ——《电影双周刊》</p><p>"一部让好莱坞都为之折服的华语电影。" ——《纽约时报》</p>',
  },
  {
    id: 10,
    title: '疯狂动物城2',
    titleEn: 'Zootopia 2',
    year: 2026,
    rating: 8.6,
    category: '动画',
    categorySlug: 'animation',
    duration: '108分钟',
    region: '美国',
    director: '拜伦·霍华德',
    cast: ['金妮弗·古德温', '杰森·贝特曼', '夏奇拉'],
    description: '尼克和朱迪再度联手，调查动物城中出现的新威胁，续写温馨爆笑的冒险故事。',
    summary: '动物城的和平再度受到威胁。新出现的犯罪团伙在城市中制造混乱，朱迪和尼克这对黄金搭档再次出击。在新朋友的帮助下，他们将揭开一个更加庞大的阴谋，同时也将面对各自过去的秘密。',
    poster: 'https://readdy.ai/api/search-image?query=animated%20animal%20city%20movie%20poster%20rabbit%20and%20fox%20detectives%20colorful%20vibrant%20Disney%20style%20playful%20dynamic%20composition%20bright%20cheerful%20lighting&width=600&height=900&seq=movie-poster-10&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=animated%20futuristic%20animal%20city%20skyline%20colorful%20modern%20buildings%20vibrant%20atmosphere%20cheerful%20Disney%20style%20cinematic%20wide%20shot&width=1600&height=700&seq=movie-banner-10&orientation=landscape',
    isHot: false,
    isNew: true,
    isClassic: false,
    releaseDate: '2026-07-22',
    tags: ['动画', '冒险', '喜剧'],
    viewCount: 5800000,
    contentHtml: '<h2>剧情简介</h2><p>动物城的和平再度受到威胁。新出现的犯罪团伙在城市中制造混乱，朱迪和尼克这对黄金搭档再次出击。</p><p>在新朋友的帮助下，他们将揭开一个更加庞大的阴谋，同时也将面对各自过去的秘密。更加精彩的冒险、更加温暖的情感，让这部续集不负期待。</p><h2>幕后制作</h2><p>迪士尼动画工作室历时五年打造，原班人马悉数回归。影片采用了最新的渲染技术，动物城的每一个角落都比前作更加精细和生动。</p><p>新增的沙漠区和海洋区为动物城的世界观增添了更多可能性。</p><h2>演职员表</h2><p>金妮弗·古德温和杰森·贝特曼再度为朱迪和尼克配音，两人的化学反应依然出色。夏奇拉不仅为角色配音，还为影片创作了全新的主题曲。</p><h2>影片评价</h2><p>"续集不输前作，动物城的世界比我们想象的更加精彩。" ——《娱乐周刊》</p><p>"一部让大人和小孩都能找到共鸣的动画杰作。" ——《今日美国》</p>',
  },
  {
    id: 11,
    title: '子弹列车',
    titleEn: 'Bullet Train',
    year: 2025,
    rating: 8.1,
    category: '动作',
    categorySlug: 'action',
    duration: '126分钟',
    region: '美国',
    director: '大卫·雷奇',
    cast: ['布拉德·皮特', '桑德拉·布洛克', '真田广之'],
    description: '一列高速列车上，五个杀手各自接到任务，却不知彼此的目标都指向同一个人。',
    summary: '东京开往京都的新干线上，五名杀手各自登上了这趟列车。他们的任务各不相同，但命运却将他们紧紧联系在一起。当列车以300公里的时速飞驰时，一场惊险刺激的生死游戏在封闭的空间中展开。',
    poster: 'https://readdy.ai/api/search-image?query=action%20movie%20poster%20Japanese%20bullet%20train%20dynamic%20action%20scene%20neon%20colors%20fast%20motion%20cinematic%20style%20cool%20vibrant%20tones&width=600&height=900&seq=movie-poster-11&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Japanese%20Shinkansen%20bullet%20train%20speeding%20at%20night%20neon%20city%20lights%20in%20distance%20rain%20cinematic%20action%20film%20style%20dynamic%20motion&width=1600&height=700&seq=movie-banner-11&orientation=landscape',
    isHot: false,
    isNew: false,
    isClassic: false,
    releaseDate: '2025-08-15',
    tags: ['动作', '黑色幽默', '日本'],
    viewCount: 9800000,
    contentHtml: '<h2>剧情简介</h2><p>东京开往京都的新干线上，五名杀手各自登上了这趟列车。他们的任务各不相同，但命运却将他们紧紧联系在一起。</p><p>当列车以300公里的时速飞驰时，一场惊险刺激的生死游戏在封闭的空间中展开。每个杀手都有自己的故事，每个故事都与其他人交织。</p><h2>幕后制作</h2><p>影片灵感来源于日本作家伊坂幸太郎的小说，动作场面由《疾速追杀》团队打造。导演大卫·雷奇以其独特的视觉风格和幽默感，为这部动作片注入了全新的活力。</p><h2>演职员表</h2><p>布拉德·皮特在片中展现了他标志性的魅力与幽默感。桑德拉·布洛克和真田广之的加盟为影片增添了更多看点。</p><h2>影片评价</h2><p>"一趟充满惊喜的高速列车之旅，动作与喜剧的完美结合。" ——《综艺》</p><p>"布拉德·皮特的状态依然无敌，这部电影太好看了。" ——《环球银幕》</p>',
  },
  {
    id: 12,
    title: '千与千寻',
    titleEn: 'Spirited Away',
    year: 2001,
    rating: 9.4,
    category: '动画',
    categorySlug: 'animation',
    duration: '125分钟',
    region: '日本',
    director: '宫崎骏',
    cast: ['柊瑠美', '入野自由', '夏木真理'],
    description: '宫崎骏的传世经典，一个关于成长、勇气与爱的奇幻故事，感动了全世界的观众。',
    summary: '10岁的千寻和父母误入了一个神灵的世界。父母因贪吃变成了猪，千寻为了拯救父母，在汤婆婆的汤屋中工作。在白龙的帮助下，千寻在这个奇幻世界中成长，最终找回了自己，也拯救了父母。',
    poster: 'https://readdy.ai/api/search-image?query=Studio%20Ghibli%20Spirited%20Away%20movie%20poster%20young%20girl%20in%20Japanese%20bathhouse%20spirit%20world%20whimsical%20fantasy%20soft%20colors%20magical%20atmosphere&width=600&height=900&seq=movie-poster-12&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Japanese%20magical%20spirit%20bathhouse%20at%20night%20Studio%20Ghibli%20style%20whimsical%20fantasy%20scene%20lanterns%20floating%20colorful%20warm%20magical%20atmosphere&width=1600&height=700&seq=movie-banner-12&orientation=landscape',
    isHot: false,
    isNew: false,
    isClassic: true,
    releaseDate: '2001-07-20',
    tags: ['经典', '吉卜力', '奥斯卡'],
    viewCount: 158000000,
    contentHtml: '<h2>剧情简介</h2><p>10岁的千寻和父母误入了一个神灵的世界。父母因贪吃变成了猪，千寻为了拯救父母，在汤婆婆的汤屋中工作。</p><p>在白龙的帮助下，千寻在这个奇幻世界中不断成长。她学会了勇敢、学会了坚持、学会了爱。最终找回了自己，也拯救了父母。宫崎骏用这个奇幻故事，讲述了一个关于成长的永恒主题。</p><h2>获奖记录</h2><p>本片荣获第75届奥斯卡金像奖最佳动画长片，成为迄今唯一获得该奖项的非英语动画电影。同时还获得了柏林电影节金熊奖。</p><h2>演职员表</h2><p>柊瑠美为千寻配音，她的声音完美诠释了千寻从胆怯到勇敢的成长历程。入野自由为白龙配音，温柔而神秘的声线令人难忘。</p><h2>影片评价</h2><p>"宫崎骏的杰作，世界上最伟大的动画电影之一。" ——《芝加哥太阳报》</p><p>"一部关于成长的最美寓言，每次看都有新的感动。" ——《朝日新闻》</p>',
  },
];

export const hotMovies = movies.filter(m => m.isHot);
export const newMovies = movies.filter(m => m.isNew);
export const classicMovies = movies.filter(m => m.isClassic);
export const topRatedMovies = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 10);
export const mostViewedMovies = [...movies].sort((a, b) => b.viewCount - a.viewCount).slice(0, 10);